export function formatAlphaNumeric(value) {
  return value
    .toString()
    .replace(/[^\dA-Za-z]/g, '')
    .trim();
}
